import type { OpenBillSelectedEventData } from "@/data/model/Bill";

import OpenBillsForTablePopoverContent from "@/app/components/bill/OpenBillsForTablePopoverContent.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class OpenBillsForTablePopover extends VueContentPopover {
    constructor(tableId: string, onOpenBillSelected: (openBill: OpenBillSelectedEventData) => void) {
        super({ popoverClass: "open-bills-for-table-popover", fullscreen: false, flexHeight: true, condensed: true });

        const props = {
            tableId: tableId,
            onClose: () => this.hide(),
            onOpenBillSelected: (openBill: OpenBillSelectedEventData) => onOpenBillSelected(openBill),
        };
        this.initComponent(OpenBillsForTablePopoverContent, props);
    }
}
